"use client";

import { c as _c } from "react/compiler-runtime";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { getDomainColor } from "@/lib/domainColors";
interface ClientPaginationProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
  itemsPerPage: number;
  onItemsPerPageChange: (count: number) => void;
  totalItems: number;
  startIndex: number;
  endIndex: number;
  domain: string;
}
export function ClientPagination(t0) {
  const $ = _c(54);
  const {
    currentPage,
    totalPages,
    onPageChange,
    itemsPerPage,
    onItemsPerPageChange,
    totalItems,
    startIndex,
    endIndex,
    domain
  } = t0;
  let t1;
  if ($[0] !== domain) {
    t1 = getDomainColor(domain);
    $[0] = domain;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const domainColor = t1;
  const isVoiceJeju = domain.toLowerCase().includes("voicejeju");
  if (totalItems <= 10) {
    return null;
  }
  let t2;
  if ($[2] !== onPageChange) {
    t2 = page => {
      onPageChange(page);
      setTimeout(_temp, 80);
    };
    $[2] = onPageChange;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const handlePageChange = t2;
  let t3;
  if ($[4] !== onItemsPerPageChange || $[5] !== onPageChange) {
    t3 = count => {
      onItemsPerPageChange(count);
      onPageChange(1);
      setTimeout(_temp2, 80);
    };
    $[4] = onItemsPerPageChange;
    $[5] = onPageChange;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const handleItemsPerPageChange = t3;
  const t4 = `text-sm text-gray-500 ${isVoiceJeju ? "font-voltaire tracking-wider uppercase" : ""}`;
  const t5 = startIndex + 1;
  const t6 = Math.min(endIndex, totalItems);
  let t7;
  if ($[7] !== t4 || $[8] !== t5 || $[9] !== t6 || $[10] !== totalItems) {
    t7 = <div className={t4}>{t5}–{t6} of {totalItems}</div>;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
    $[10] = totalItems;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== currentPage || $[13] !== handlePageChange) {
    t8 = () => handlePageChange(Math.max(1, currentPage - 1));
    $[12] = currentPage;
    $[13] = handlePageChange;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  const t9 = currentPage === 1;
  const t10 = `p-2 rounded-none transition-colors ${currentPage === 1 ? "text-gray-300 cursor-not-allowed" : "text-gray-600 hover:bg-gray-100 hover:text-gray-900"}`;
  let t11;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <ChevronLeft className="w-4 h-4" />;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] !== t10 || $[17] !== t8 || $[18] !== t9) {
    t12 = <button type="button" onClick={t8} disabled={t9} className={t10} aria-label="Previous page">{t11}</button>;
    $[16] = t10;
    $[17] = t8;
    $[18] = t9;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  const t13 = `px-3 text-sm text-gray-700 ${isVoiceJeju ? "font-voltaire tracking-wider uppercase text-base" : ""}`;
  let t14;
  if ($[20] !== currentPage || $[21] !== t13 || $[22] !== totalPages) {
    t14 = <div className={t13}>Page {currentPage} of {totalPages}</div>;
    $[20] = currentPage;
    $[21] = t13;
    $[22] = totalPages;
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  let t15;
  if ($[24] !== currentPage || $[25] !== handlePageChange || $[26] !== totalPages) {
    t15 = () => handlePageChange(Math.min(totalPages, currentPage + 1));
    $[24] = currentPage;
    $[25] = handlePageChange;
    $[26] = totalPages;
    $[27] = t15;
  } else {
    t15 = $[27];
  }
  const t16 = currentPage === totalPages;
  const t17 = `p-2 rounded-none transition-colors ${currentPage === totalPages ? "text-gray-300 cursor-not-allowed" : "text-gray-600 hover:bg-gray-100 hover:text-gray-900"}`;
  let t18;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <ChevronRight className="w-4 h-4" />;
    $[28] = t18;
  } else {
    t18 = $[28];
  }
  let t19;
  if ($[29] !== t15 || $[30] !== t16 || $[31] !== t17) {
    t19 = <button type="button" onClick={t15} disabled={t16} className={t17} aria-label="Next page">{t18}</button>;
    $[29] = t15;
    $[30] = t16;
    $[31] = t17;
    $[32] = t19;
  } else {
    t19 = $[32];
  }
  let t20;
  if ($[33] !== t12 || $[34] !== t14 || $[35] !== t19) {
    t20 = <div className="flex items-center gap-1">{t12}{t14}{t19}</div>;
    $[33] = t12;
    $[34] = t14;
    $[35] = t19;
    $[36] = t20;
  } else {
    t20 = $[36];
  }
  const t21 = `text-[10px] font-black uppercase tracking-[0.2em] text-gray-400 mr-1 ${isVoiceJeju ? "font-voltaire tracking-[0.25em]" : ""}`;
  let t22;
  if ($[37] !== t21) {
    t22 = <span className={t21}>Show:</span>;
    $[37] = t21;
    $[38] = t22;
  } else {
    t22 = $[38];
  }
  let t23;
  if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = [10, 15, 20];
    $[39] = t23;
  } else {
    t23 = $[39];
  }
  let t24;
  if ($[40] !== totalItems) {
    t24 = t23.filter(count_0 => {
      if (count_0 === 20) {
        return totalItems > 15;
      }
      if (count_0 === 15) {
        return totalItems > 10;
      }
      return true;
    });
    $[40] = totalItems;
    $[41] = t24;
  } else {
    t24 = $[41];
  }
  let t25;
  if ($[42] !== domainColor || $[43] !== handleItemsPerPageChange || $[44] !== itemsPerPage || $[45] !== t24) {
    t25 = t24.map(count_1 => <button key={count_1} type="button" onClick={() => handleItemsPerPageChange(count_1)} className={`px-2.5 py-1 text-xs font-medium rounded-none transition-colors ${itemsPerPage === count_1 ? "text-white shadow-sm font-semibold" : "text-gray-600 hover:bg-gray-100"}`} style={itemsPerPage === count_1 ? {
      backgroundColor: domainColor.hex
    } : {}}>{count_1}</button>);
    $[42] = domainColor;
    $[43] = handleItemsPerPageChange;
    $[44] = itemsPerPage;
    $[45] = t24;
    $[46] = t25;
  } else {
    t25 = $[46];
  }
  let t26;
  if ($[47] !== t22 || $[48] !== t25) {
    t26 = <div className="flex items-center gap-1.5">{t22}{t25}</div>;
    $[47] = t22;
    $[48] = t25;
    $[49] = t26;
  } else {
    t26 = $[49];
  }
  let t27;
  if ($[50] !== t20 || $[51] !== t26 || $[52] !== t7) {
    t27 = <div className="mt-8 pt-6 border-t border-gray-100"><div className="flex flex-col sm:flex-row items-center justify-between gap-4 w-full text-center sm:text-left">{t7}{t20}{t26}</div></div>;
    $[50] = t20;
    $[51] = t26;
    $[52] = t7;
    $[53] = t27;
  } else {
    t27 = $[53];
  }
  return t27;
}
function _temp2() {
  const element_0 = document.getElementById("latest-stories");
  if (element_0) {
    element_0.scrollIntoView({
      behavior: "auto"
    });
  } else {
    window.scrollTo({
      top: 0,
      behavior: "auto"
    });
  }
}
function _temp() {
  const element = document.getElementById("latest-stories");
  if (element) {
    element.scrollIntoView({
      behavior: "auto"
    });
  } else {
    window.scrollTo({
      top: 0,
      behavior: "auto"
    });
  }
}